import ApplicationsIndexPage from "@/pages/applications/ApplicationsIndexPage";
import ApplicationPage from "@/pages/applications/ApplicationPage";
import ProtectedRoute from "@/components/helpers/ProtectedRoute";

const ApplicationRoutes = [
  {
    path: "applications",
    element: (
      <ProtectedRoute>
        <ApplicationsIndexPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "applications/:applicationId",
    element: (
      <ProtectedRoute>
        <ApplicationPage />
      </ProtectedRoute>
    ),
  },
];

export default ApplicationRoutes;
